import Career from "~/components/icons/career-eon";
import Culture from "~/components/icons/culture-eon";
import Development from "~/components/icons/development-eon";
import Health from "~/components/icons/health-eon";
import Onboarding from "~/components/icons/onboarding-eon";
import Purpose from "~/components/icons/purpose-eon";
import Recognition from "~/components/icons/recognition-eon";
import Sustainability from "~/components/icons/sustainability-eon";
import WorkLife from "~/components/icons/work-life-eon";
import type { TranslationsMap } from "~/translations/loader/init";
import type { Benefit } from "./benefits-eon";

export const benefitsDefault = (text: TranslationsMap): Benefit[] => [
  {
    id: 1,
    icon: <Purpose className="size-20 text-current" />,
    title: text.jobad_benefits_purpose_title,
    text: text.jobad_benefits_purpose,
  },
  {
    id: 2,
    icon: <Sustainability className="size-20 text-current" />,
    title: text.jobad_benefits_sustainability_title,
    text: text.jobad_benefits_sustainability,
  },
  {
    id: 3,
    icon: <Culture className="size-20 text-current" />,
    title: text.jobad_benefits_culture_title,
    text: text.jobad_benefits_culture,
  },
  {
    id: 4,
    icon: <Recognition className="size-20 text-current" />,
    title: text.jobad_benefits_recognition_title,
    text: text.jobad_benefits_recognition,
  },
  {
    id: 5,
    icon: <WorkLife className="size-20 text-current" />,
    title: text.jobad_benefits_workLife_title,
    text: text.jobad_benefits_workLife,
  },
  {
    id: 6,
    icon: <Health className="size-20 text-current" />,
    title: text.jobad_benefits_health_title,
    text: text.jobad_benefits_health,
  },
  {
    id: 7,
    icon: <Career className="size-20 text-current" />,
    title: text.jobad_benefits_career_title,
    text: text.jobad_benefits_career,
  },
  {
    id: 8,
    icon: <Development className="size-20 text-current" />,
    title: text.jobad_benefits_development_title,
    text: text.jobad_benefits_development,
  },
  {
    id: 9,
    icon: <Onboarding className="size-20 text-current" />,
    title: text.jobad_benefits_onboarding_title,
    text: text.jobad_benefits_onboarding,
  },
];
